import { PropsWithChildren } from 'react'

import { useCreation } from 'ahooks'

import { CrudModalFormStoreContext } from './contexts/StoreContext'
import { CrudModalFormStoreProviderProps } from './interface'
import { createCrudModalFormStore } from './store/createStore'
import { CrudModalFormStoreUpdater } from './StoreUpdater'

export const CrudModalFormStoreProvider = ({
  /* -------------------------------------------------------------------------- */
  /*                       CrudModalFormStoreUpdater Props                      */
  /* -------------------------------------------------------------------------- */
  open,
  onOpenChange,

  /* -------------------------------------------------------------------------- */
  /*                       createCrudModalFormStore Props                       */
  /* -------------------------------------------------------------------------- */
  children
}: PropsWithChildren<CrudModalFormStoreProviderProps>) => {
  const store = useCreation(() => createCrudModalFormStore(), [])

  return (
    <CrudModalFormStoreContext value={store}>
      <CrudModalFormStoreUpdater open={open} onOpenChange={onOpenChange} />
      {children}
    </CrudModalFormStoreContext>
  )
}
